import axios from 'axios'

const api = axios.create({
  baseURL: '/api',
  timeout: 300000,        // 5 phút – đủ cho ping 100 lần
  withCredentials: true,  // gửi session cookie
})

export default api
